import Vue from 'vue'

const KeycloakInstance = {
  isAuth: () => Vue.prototype.$keycloak.authenticated,
  getFullName: () => Vue.prototype.$keycloak.fullName,
  getToken: () => Vue.prototype.$keycloak.token,
  getRefreshToken: () => Vue.prototype.$keycloak.refreshToken
}

export default KeycloakInstance
